import React from 'react';
import ProfileImage from './ProfileImage';

import styles from './CommitteeMemberCard.module.css';

const CommitteeMemberCard = ({ member }) => {
  return (
    <div className={styles.container}>
      <ProfileImage className={styles.profileImage} photo={member.photo} disableClick />
      <div className={styles.nameWrapper}>
        <div className={styles.nameText}>{member.name}</div>
        <div>{member.post}</div>
        {member.relation ? <div className={styles.subText}>{member.relation}</div> : null}
      </div>
    </div>
  );
};

export default CommitteeMemberCard;
